// Sentry initialization should be imported first!
import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ReferralLandingPage from './components/ReferralLandingPage';
import SentryCanaryPage from './components/SentryCanaryPage';
import reportWebVitals from './reportWebVitals';
import SpeechChat from './components/SpeechChat';
import WatermarkTest from './components/WatermarkTest';
import { installDomMutationGuard } from './utils/domMutationGuard';

installDomMutationGuard();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {window.location.pathname === '/watermark-test' ? (
      <WatermarkTest />
    ) : window.location.pathname === '/sentry-canary' ? (
      <SentryCanaryPage />
    ) : window.location.pathname === '/speech-chat-demo' ? (
      <SpeechChat />
    ) : window.location.pathname.startsWith('/referral') ? (
      <ReferralLandingPage
        referrerFirst={new URLSearchParams(window.location.search).get('ref') || undefined}
        magicLink={new URLSearchParams(window.location.search).get('magic') || undefined}
      />
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
